<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
    >
        <path
            fill-rule="evenodd"
            d="M15.79 5.23a.75.75 0 0 1-.02 1.06L9.832 12l5.938 5.71a.75.75 0 1 1-1.04 1.08l-6.5-6.25a.75.75 0 0 1 0-1.08l6.5-6.25a.75.75 0 0 1 1.06.02Z"
            clip-rule="evenodd"
        />
    </svg>
</template>

<script>
export default { name: "ChevronLeftIcon" };
</script>
